/* ==========================================================================
   KingCase - correctif upload photo
   --------------------------------------------------------------------------
   Probleme corrige : sur les navigateurs constructeurs (Xiaomi, Huawei,
   Oppo, Vivo...), un champ fichier cache declenche par du JavaScript
   (.click()) est bloque : rien ne se passe quand le client tape sur
   "Choisir un fichier".

   Principe du correctif : on rend le VRAI champ fichier tapable, superpose
   en transparence sur le bouton visible. Le clic vient donc reellement du
   doigt du client, et la galerie s'ouvre normalement.

   Le message "Un souci pour ajouter votre photo ?" a ete retire (19/10/2026).

   Pour desactiver : supprimer la ligne kc-upload-fix.js dans
   layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var DONE = 'kcFixed';

  function num(v) { return parseFloat(v) || 0; }

  /* Le champ est-il impossible a taper pour le client ? */
  function isUnclickable(el) {
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return true;
    if (num(cs.opacity) < 0.05) return true;
    if (cs.pointerEvents === 'none') return true;
    var r = el.getBoundingClientRect();
    if (r.width < 8 || r.height < 8) return true;
    return false;
  }

  /* Remonte jusqu'au conteneur visible qui fait office de bouton */
  function findHost(input) {
    var node = input.parentElement;
    var depth = 0;
    while (node && depth < 6) {
      var cs = window.getComputedStyle(node);
      // Conteneur masque qui n'enveloppe que le champ : on le neutralise
      if (cs.display === 'none' && node.childElementCount === 1) {
        node.style.display = 'contents';
        cs = window.getComputedStyle(node);
      }
      var r = node.getBoundingClientRect();
      if (cs.display !== 'none' && r.width >= 40 && r.height >= 20) return node;
      node = node.parentElement;
      depth++;
    }
    return null;
  }

  function patchInput(input) {
    if (input.dataset[DONE]) return;
    input.dataset[DONE] = '1';

    // 1. Une liste d'extensions (.jpg,.png) est mal geree par ces navigateurs
    var accept = input.getAttribute('accept') || '';
    if (!accept || accept.indexOf('.') !== -1) input.setAttribute('accept', 'image/*');

    // 2. capture force l'appareil photo et interdit l'acces a la galerie
    input.removeAttribute('capture');

    // 3. Si le champ est deja tapable, on ne touche a rien
    if (!isUnclickable(input)) return;

    var host = findHost(input);
    if (!host) return;
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var s = input.style;
    s.setProperty('position', 'absolute', 'important');
    s.setProperty('top', '0', 'important');
    s.setProperty('left', '0', 'important');
    s.setProperty('width', '100%', 'important');
    s.setProperty('height', '100%', 'important');
    s.setProperty('display', 'block', 'important');
    s.setProperty('visibility', 'visible', 'important');
    s.setProperty('opacity', '0', 'important');
    s.setProperty('z-index', '9', 'important');
    s.setProperty('cursor', 'pointer', 'important');
    s.setProperty('pointer-events', 'auto', 'important');
    s.setProperty('font-size', '0', 'important');
  }

  function scan() {
    var inputs = document.querySelectorAll('input[type="file"]');
    for (var i = 0; i < inputs.length; i++) patchInput(inputs[i]);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 120);
  }

  function start() {
    scan();
    // L'application d'options injecte ses champs apres le chargement
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    }
    var n = 0;
    var t = setInterval(function () { scan(); if (++n > 20) clearInterval(t); }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
